import { render, staticRenderFns } from "./shiba.vue?vue&type=template&id=257fe9e8"
import script from "./shiba.vue?vue&type=script&lang=js"
export * from "./shiba.vue?vue&type=script&lang=js"
import style0 from "./shiba.vue?vue&type=style&index=0&id=257fe9e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports